import { render, staticRenderFns } from "./familiaProductoAddEdit.vue?vue&type=template&id=14115548&scoped=true&"
import script from "./familiaProductoAddEdit.vue?vue&type=script&lang=js&"
export * from "./familiaProductoAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./familiaProductoAddEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./familiaProductoAddEdit.vue?vue&type=style&index=1&id=14115548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14115548",
  null
  
)

export default component.exports